// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"i2-z","colorTextValue":"j2-z","swatches":"k2-z","collapseLink":"l2-z","isCollapsed":"m2-z","dropdown":"n2-z","disabled":"o2-z"};